import { AuthError } from "@/lib/auth/errors/auth-error";
import type { AuthInstance, LoginChallenge, LoginSession } from "../types";
import { wrapper } from "./wrapper";

export const sendLoginChallenge =
  (client: AuthInstance) =>
  async (loginSession: LoginSession, code: string): Promise<void> => {
    const response = await wrapper(() => {
      return client.sendCustomChallengeAnswer(
        loginSession,
        code,
      ) as Promise<LoginChallenge>;
    });

    if (response.signInUserSession == null) {
      throw new AuthError({
        code: "ChallengeFailedException",
        message: "ChallengeFailedException",
      });
    }
  };
